import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { faAsterisk } from '@fortawesome/pro-regular-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { LabelComponent } from '@reconcept-platform/shared/ui/standalone/label';
import { RcpPopoverDirective } from '@reconcept-platform/shared/ui/standalone/popover';

@Component({
  selector: 'rcp-custom-skill-label',
  template: `
    <rcp-label
      color="neutral"
      [icon]="faAsterisk"
      [rcpPopover]="'qz-this-is-custom-skill-zm' | translate"
      [rcpPopoverIsEnabled]="showTooltip"
    ></rcp-label>
  `,
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
  imports: [RcpPopoverDirective, TranslatePipe, LabelComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CustomSkillLabelComponent {
  @Input() showTooltip = true;
  @Input() transparent = true;

  faAsterisk = faAsterisk;
}
